import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudRadioButtonModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentDeleteRecurrencyModalComponent } from './appointment-delete-recurrency-modal.component';

@NgModule({
	declarations: [AppointmentDeleteRecurrencyModalComponent],
	imports: [
		CommonModule,
		FreudDialogModule,
		FreudButtonModule,
		TranslateModule,
		FreudRadioButtonModule,
		FormsModule,
	],
	exports: [AppointmentDeleteRecurrencyModalComponent],
	providers: [],
})
export class AppointmentDeleteRecurrencyModalModule {}
